import {
  configureStore as _configureStore,
  ConfigureStoreOptions,
  EnhancedStore,
} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer, {RootState} from './rootReducer';
import rootSaga from './rootSaga';

export function configureStore(
  options?: Partial<ConfigureStoreOptions<RootState>>,
): EnhancedStore<RootState> {
  const sagaMiddleware = createSagaMiddleware();

  const store = _configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: false,
      }).concat(sagaMiddleware),
    ...options,
  });

  sagaMiddleware.run(rootSaga);

  return store;
}

export default configureStore();
